/*global
    jQuery
*/
(function ($) {
    var resourceMap = {
        'pet-completion-notice': '/mypets/dismiss-pet-completion-notice',
        'pet-documents-notice': '/mypets/dismiss-pet-documents-notice',
        'pet-contract-notice': '/mypets/dismiss-pet-contract-notice',
    };

    var dismissNotice = function(type) {
        var url = resourceMap[type];
        if ( typeof url !== 'undefined' ) {
            $.get(url, function(data, status) {
                if ( typeof data !== 'undefined' && typeof data.status !== 'undefined' ) {
                    $('div.'+type).fadeOut(500);
                    fireGAEvent(type);
                }
            });
        }
    }

    var fireGAEvent = function(type) {
        ga('send', 'event', 'Owner Notifications', 'Closed Notice', 'User closed notification type: ' + type);
    }

    $.each(resourceMap, function(type, url) {
        var $banner = $('div.'+type);
        if ( typeof $banner !== 'undefined' && $banner.length > 0 ) {
            $banner.find('button.close-button').on('click', function() {
                dismissNotice(type);
            });
        }
    });

    var $statusSelect = $('select[name="pet-status"]');

    var submitStatusChange = function() {
        if (typeof $statusSelect !== 'undefined' && $statusSelect.val() !== '') {
            var newStatus = $statusSelect.val();
            var pet_id = $('input[name="pet_id"]').val();
            window.location.href='/mypets/change-status/'+pet_id+'/'+newStatus;
        }
    }

    $statusSelect.on('change', submitStatusChange);
}(jQuery));
